import { GalleryItem } from "unmuted-lightgallery/dist/lg-utils";
import { LgQuery } from "unmuted-lightgallery/dist/lgQuery";
import { LightGallery } from "unmuted-lightgallery/dist/lightgallery";
import toast from 'react-hot-toast';

export interface CopyVideoLinkSettings {
  copyButtonLabel: string;
  copyButtonHTML: string;
}

export const copyVideoLinkSettings: CopyVideoLinkSettings = {
  copyButtonHTML: '<svg width="23" height="23" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="link"><path id="Vector" fill-rule="evenodd" clip-rule="evenodd" d="M15.103 5.5032C15.3244 5.27398 15.5892 5.09114 15.882 4.96536C16.1748 4.83958 16.4898 4.77337 16.8084 4.7706C17.1271 4.76783 17.4431 4.82856 17.7381 4.94923C18.033 5.0699 18.301 5.24811 18.5264 5.47345C18.7517 5.6988 18.9299 5.96676 19.0506 6.26171C19.1713 6.55666 19.232 6.87269 19.2292 7.19136C19.2264 7.51004 19.1602 7.82496 19.0344 8.11777C18.9087 8.41058 18.7258 8.67541 18.4966 8.8968L14.8966 12.4968C14.4465 12.9467 13.8362 13.1995 13.1998 13.1995C12.5634 13.1995 11.9531 12.9467 11.503 12.4968C11.2767 12.2782 10.9736 12.1573 10.6589 12.16C10.3443 12.1627 10.0433 12.2889 9.82082 12.5114C9.59833 12.7339 9.47213 13.0349 9.4694 13.3495C9.46666 13.6642 9.58761 13.9673 9.8062 14.1936C10.7063 15.0935 11.927 15.599 13.1998 15.599C14.4726 15.599 15.6933 15.0935 16.5934 14.1936L20.1934 10.5936C21.0678 9.68831 21.5516 8.47582 21.5406 7.21728C21.5297 5.95873 21.0249 4.75483 20.1349 3.86487C19.245 2.97491 18.0411 2.4701 16.7825 2.45917C15.524 2.44823 14.3115 2.93204 13.4062 3.8064L11.6062 5.6064C11.4916 5.7171 11.4002 5.84951 11.3373 5.99592C11.2744 6.14232 11.2413 6.29978 11.2399 6.45912C11.2385 6.61846 11.2689 6.77647 11.3292 6.92395C11.3896 7.07142 11.4787 7.2054 11.5913 7.31808C11.704 7.43075 11.838 7.51985 11.9855 7.58019C12.1329 7.64052 12.2909 7.67089 12.4503 7.6695C12.6096 7.66812 12.7671 7.63501 12.9135 7.57212C13.0599 7.50923 13.1923 7.41781 13.303 7.3032L15.103 5.5032ZM9.103 11.5032C9.55307 11.0533 10.1634 10.8005 10.7998 10.8005C11.4362 10.8005 12.0465 11.0533 12.4966 11.5032C12.6073 11.6178 12.7397 11.7092 12.8861 11.7721C13.0325 11.835 13.19 11.8681 13.3493 11.8695C13.5087 11.8709 13.6667 11.8405 13.8141 11.7802C13.9616 11.7199 14.0956 11.6307 14.2083 11.5181C14.3209 11.4054 14.4101 11.2714 14.4704 11.1239C14.5307 10.9765 14.5611 10.8185 14.5597 10.6591C14.5583 10.4998 14.5252 10.3423 14.4623 10.1959C14.3994 10.0495 14.308 9.9171 14.1934 9.8064C13.2933 8.90654 12.0726 8.40103 10.7998 8.40103C9.52702 8.40103 8.30634 8.90654 7.4062 9.8064L3.8062 13.4064C3.34775 13.8492 2.98208 14.3788 2.73052 14.9645C2.47895 15.5501 2.34654 16.1799 2.341 16.8173C2.33546 17.4546 2.45691 18.0867 2.69826 18.6766C2.93961 19.2665 3.29602 19.8024 3.74671 20.2531C4.19739 20.7038 4.73332 21.0602 5.32322 21.3015C5.91313 21.5429 6.54519 21.6643 7.18253 21.6588C7.81987 21.6533 8.44973 21.5209 9.03535 21.2693C9.62096 21.0177 10.1506 20.6521 10.5934 20.1936L12.3934 18.3936C12.508 18.2829 12.5994 18.1505 12.6623 18.0041C12.7252 17.8577 12.7583 17.7002 12.7597 17.5409C12.7611 17.3815 12.7307 17.2235 12.6704 17.0761C12.6101 16.9286 12.5209 16.7946 12.4083 16.6819C12.2956 16.5693 12.1616 16.4802 12.0141 16.4198C11.8667 16.3595 11.7087 16.3291 11.5493 16.3305C11.39 16.3319 11.2325 16.365 11.0861 16.4279C10.9397 16.4908 10.8073 16.5822 10.6966 16.6968L8.8966 18.4968C8.67521 18.726 8.41038 18.9089 8.11757 19.0346C7.82477 19.1604 7.50984 19.2266 7.19117 19.2294C6.8725 19.2322 6.55647 19.1714 6.26151 19.0508C5.96656 18.9301 5.6986 18.7519 5.47326 18.5266C5.24791 18.3012 5.06971 18.0332 4.94903 17.7383C4.82836 17.4433 4.76763 17.1273 4.7704 16.8086C4.77317 16.49 4.83938 16.175 4.96516 15.8822C5.09094 15.5894 5.27378 15.3246 5.503 15.1032L9.103 11.5032Z" fill="currentColor"/></g></svg>',
  copyButtonLabel: 'Copy media link',
};

export default class CopyVideoLink {
  core: LightGallery;
  settings: CopyVideoLinkSettings;
  private $LG!: LgQuery;

  private $btn: HTMLElement | null = null;
  private onAfterSlideRef: () => void;
  private onAfterOpenRef: () => void;
  private onBeforeCloseRef: () => void;
  private onButtonClickRef: ((e: Event) => void) | null = null;

  constructor(instance: LightGallery, $LG: LgQuery) {
    this.core = instance;
    this.$LG = $LG;

    this.settings = {
      ...copyVideoLinkSettings,
      ...(this.core.settings as Partial<CopyVideoLinkSettings>),
    } as CopyVideoLinkSettings;

    this.onAfterSlideRef = this.onAfterSlide.bind(this);
    this.onAfterOpenRef = this.onAfterSlide.bind(this);
    this.onBeforeCloseRef = this.onBeforeClose.bind(this);

    return this;
  }

  init(): void {
    this.core.LGel.on('lgAfterOpen', this.onAfterOpenRef);
    this.core.LGel.on('lgAfterSlide', this.onAfterSlideRef);
    this.core.LGel.on('lgBeforeClose', this.onBeforeCloseRef);
  }

  destroy(): void {
    this.removeButton();
    this.core.LGel.off('lgAfterOpen');
    this.core.LGel.off('lgAfterSlide');
    this.core.LGel.off('lgBeforeClose');
  }

  private onBeforeClose(): void {
    this.removeButton();
  }

  private onAfterSlide(): void {
    const index = this.core.index;
    const item = this.core.galleryItems[index];

    this.removeButton();

    if (!item) return;

    this.appendButton(item);
  }

  private appendButton(item: GalleryItem): void {
    const toolbarEl = this.core.outer.find('.lg-toolbar').get();
    if (!toolbarEl) return;

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'lg-icon lg-copy-btn';
    btn.style.display = 'flex';
    btn.style.alignItems = 'center';
    btn.style.justifyContent = 'center';
    btn.title = this.settings.copyButtonLabel;
    btn.setAttribute('aria-label', this.settings.copyButtonLabel);
    btn.innerHTML = this.settings.copyButtonHTML;

    this.onButtonClickRef = () => {
      const url = item?.src || item?.video?.source[0]?.src;
      if (!url) {
        toast.error('Could not copy link');
      } else {
        navigator.clipboard.writeText(url);
        toast.success('Link copied to clipboard');
      }
    };

    btn.addEventListener('click', this.onButtonClickRef);

    toolbarEl.appendChild(btn);
    this.$btn = btn;
  }

  private removeButton(): void {
    if (this.$btn) {
      if (this.onButtonClickRef) {
        this.$btn.removeEventListener('click', this.onButtonClickRef);
        this.onButtonClickRef = null;
      }
      this.$btn.remove();
      this.$btn = null;
    }
  }
}